<template>
  <div class="main-container">
    <img class="main-bg" src="@/assets/main/bg.png" alt="" />
    <div class="main-header">
      <img src="@/assets/main/bg_head.png" alt="" />
      <div class="header-con">
        <!-- <div class="logo">
          <img src="@/assets/logo.png" alt="" />
        </div> -->
        <div class="main-title">
          <img :src="textImg" alt="" />
        </div>
      </div>
    </div>
    <slot></slot>
    <div class="main-floor bounceInUp animated">
      <img src="../../assets/main/bg_dibu.png" alt="" />
      <div class="main-floor-con">
        <div class="bot">
          友情链接：<span
            class="link"
            @click="jump('http://www.moe.gov.cn/s78/A08/')"
            >教育部高教司</span
          >
          |
          <span class="link" @click="jump('https://jyt.hlj.gov.cn/')"
            >教育厅</span
          >
          |
          <span class="link" @click="Goto">实验实习实践智慧管理平台</span>
          |
          <span class="link" @click="jump('http://122.51.76.10:8100/')">高水平人才培养改革实验区建设平台</span>
          |
          <span class="link" @click="jump('https://higher.smartedu.cn/')"
            >高教智慧平台</span
          >
        </div>
        <div>
          地址：黑龙江省哈尔滨市南岗区红军街75号
          联系电话：0451-53623756、19524511118 联系邮箱：18686739927@126.com
          Copyright © 2024 教育厅高教处 版权所有 沪ICP备2021028823号
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
    textImg: String,
  },
  data() {
    return {
      Img: "",
    };
  },
  methods: {
    jump(url) {
      window.open(url);
    },
    Goto() {
      window.location.href = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.main-container {
  position: relative;
  .main-bg {
    width: 100vw;
    height: 100vh;
    object-fit: cover;
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
  }
  img {
    width: 100%;
  }

  .main-header {
    position: relative;
    z-index: 2;

    .header-con {
      position: absolute;
      z-index: 2;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      padding: 0 1.5625vw;

      .logo {
        width: 3vw;
        height: 3vw;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.625vw;
      }

      .main-title {
        height: 2.447916vw;

        img {
          width: auto;
          height: 100%;
        }
      }
    }
  }
  .main-floor {
    position: relative;
    z-index: 2;
    padding: 0 1.0416666666vw 0.7vw;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
    }

    .main-floor-con {
      position: absolute;
      z-index: 2;
      text-align: center;
      color: #666666;

      .bot {
        margin-bottom: 0.5vw;

        .link {
          cursor: pointer;
        }

        .link:hover {
          text-decoration: underline;
          color: blue;
        }
      }
    }
  }
}
// 响应式

@media screen and (min-width: 1200px) {
}

@media screen and (min-width: 923px) and (max-width: 1199px) {
}

@media screen and (min-width: 768px) and (max-width: 922px) {
}

@media screen and (max-width: 922px) {
  .main-container {
    display: block;
    font-size: 16px;
    height: auto;
    background-color: #dde8f8;

    .main-bg {
      height: auto;
      min-height: 100vh;
      bottom: 0;
    }

    .main-header {
      width: 100%;
      height: 44px;
      img {
        width: auto;
        height: 100%;
		object-fit: cover;
      }

      .header-con {
        display: flex;
        justify-content: center;
        align-items: center;

        .main-title {
          width: 95%;
          height: auto;

          img {
            width: 100%;
            height: auto;
          }
        }
      }
    }

    .main-floor {
      img {
        width: auto;
        height: 100%;
      }

      .main-floor-con {
        padding: 0 10px;
        line-height: 19px;
        .bot {
          font-size: 10px;

          .link {
            font-size: 10px;
          }
        }

        & > div {
          font-size: 10px;
        }
      }
    }
  }
}
</style>
